
import { eoRendererMixin, dateFormatMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    dateFormatMixin,
    metaDataMixin,
  ],
  /**
   * The initials fetch of the presenter person data
   * @param {string} params - The slug, used as index to get the person data from the Hcms
   * @returns {Promise<{ seoDescription: *, name: *, publishedOn: *, personId: *, hero: null, biography: *, seoTitle: *}>}
   */
  async asyncData ({ $api, $config, params, store, route }) {
    const { slug } = params
    const { data: { items: persons = [] } } = await $api.persons.getOneBySlug(slug, {
      domain: $config.preprEnvironmentDomainGeneriek,
    })

    // Set breadcrumbs
    await store.dispatch('breadcrumbs/set', {
      path: route.path,
      width: 10,
      eoRoot: true,
      floating: true,
      items: [
        {
          label: persons[0]?.name,
        },
      ],
    })

    return {
      ...persons[0],
    }
  },
  data () {
    return {
      programs: null,
      type: 'Presentator',
    }
  },
  computed: {
    heroCutout () {
      return this.hero?.replace('{format}', 'c_north,w_1920,h_1280')
    },
  },
  /**
   * Use watches for getting additional data from the Hcms to ensure the first byte is fast.
   */
  watch: {
    id: {
      handler: 'fetchPersonNestedPrograms',
      immediate: true,
    },
  },
  methods: {
    /**
     * Fetch the nested program objects of the given person id
     * @param {string} id - Person Id
     * @returns {Promise<void>}
     */
    async fetchPersonNestedPrograms (id) {
      const { data: { items: personPrograms = []} } = await this.$api.persons.getAllNested('programs', id, {
        domain: this.$config.preprEnvironmentDomainGeneriek,
        personType: 'presenter',
        limit: 10,
        offset: 0,
      })
      this.programs = personPrograms
    },
  },
}
